import ButtonTab from './button-tab'
import ButtonTabItem from './button-tab-item'

export {
  ButtonTab,
  ButtonTabItem
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/button-tab/index.js